module.exports = __webpack_public_path__ + "assets/images/4c8918b32ef23f1b3b7b0b38b2e3b16c.png";